// Post-login "return URL" handling, ported from EduSphere's
// apps/web/src/lib/auth-redirect.ts (RBAC audit follow-up, p3-return-url).
// Astra previously only special-cased activation/purchase/partner redirects;
// this adds a general deep-link restore so `/login?redirect=/some/page`
// (or a stored pre-OAuth path) lands the user back where they started.

const AUTH_RETURN_STORAGE_KEY = 'astra:auth-return-url';
const DEFAULT_FALLBACK = '/dashboard';

/** Only allow same-origin relative paths (open-redirect safe). */
export function sanitizeReturnUrl(value, fallback = DEFAULT_FALLBACK) {
  if (!value) return fallback;
  const trimmed = String(value).trim();
  if (!trimmed.startsWith('/') || trimmed.startsWith('//')) return fallback;
  if (trimmed.includes('://')) return fallback;
  return trimmed;
}

export function getReturnUrlFromSearch(search, fallback = DEFAULT_FALLBACK) {
  try {
    const params = new URLSearchParams(search || '');
    return sanitizeReturnUrl(params.get('redirect'), fallback);
  } catch {
    return fallback;
  }
}

export function withRedirectParam(path, returnUrl) {
  const safe = sanitizeReturnUrl(returnUrl, '');
  if (!safe || safe === DEFAULT_FALLBACK) return path;
  const sep = path.includes('?') ? '&' : '?';
  return `${path}${sep}redirect=${encodeURIComponent(safe)}`;
}

export function storeAuthReturnUrl(returnUrl) {
  try {
    if (typeof window === 'undefined' || !window.sessionStorage) return;
    const safe = sanitizeReturnUrl(returnUrl, '');
    if (!safe) {
      window.sessionStorage.removeItem(AUTH_RETURN_STORAGE_KEY);
      return;
    }
    window.sessionStorage.setItem(AUTH_RETURN_STORAGE_KEY, safe);
  } catch {
    // ignore (private browsing / storage disabled)
  }
}

export function consumeAuthReturnUrl(fallback = DEFAULT_FALLBACK) {
  try {
    if (typeof window === 'undefined' || !window.sessionStorage) return fallback;
    const stored = window.sessionStorage.getItem(AUTH_RETURN_STORAGE_KEY) || '';
    if (stored) {
      window.sessionStorage.removeItem(AUTH_RETURN_STORAGE_KEY);
    }
    return sanitizeReturnUrl(stored, fallback);
  } catch {
    return fallback;
  }
}
